export default __webpack_public_path__ + "static/media/Poppins-Bold.9f0cd50b.ttf";